export const httpMethods = [
  'GET',
  'POST',
  'PUT',
  'DELETE',
  'PATCH',
  'TRACE',
  'OPTIONS',
  'CONNECT',
  'HEAD',
]
